import React from 'react';
import { Sparkles, ShieldCheck, HeartHandshake, MapPin } from 'lucide-react';
const props = [{
  icon: Sparkles,
  text: 'Medical-grade results'
}, {
  icon: ShieldCheck,
  text: 'Licensed injectors & estheticians'
}, {
  icon: HeartHandshake,
  text: 'Personalized treatment maps'
}, {
  icon: MapPin,
  text: 'San Ramon, CA'
}];
export const TrustStrip = () => {
  return <section className="w-full bg-white py-12 px-4" data-id="element-212">
      <div className="max-w-6xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-213">
        {props.map((p, i) => <div key={i} className="flex flex-col items-center text-center gap-3" data-id="element-214">
            <div className="w-12 h-12 rounded-full bg-be-pink/10 flex items-center justify-center text-be-pink" data-id="element-215">
              <p.icon size={24} data-id="element-216" />
            </div>
            <p className="text-be-navy font-bold text-sm uppercase tracking-wider" data-id="element-217">
              {p.text}
            </p>
          </div>)}
      </div>
    </section>;
};